import { CloseOutlined } from "@mui/icons-material";
import Modal from "@mui/material/Modal";
import cryptoRandomString from "crypto-random-string";
import { sha256 } from "js-sha256";
import Image from "next/legacy/image";
import { useState } from "react";
import NumberFormat from "react-number-format";

import { generateKeyPair } from "../auth/generateKeyPair";
import AppleStore from "../icons/app-store";
import PlayStore from "../icons/play store";

import styles from "@/styles/modal.module.scss";

export default function BasicModal({ open, handleClose }) {
  const [phoneError, setPhoneError] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [formSent, setFormSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const formSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    if (phoneNumber === null || phoneNumber.length < 1) {
      setPhoneError("empty");
      setLoading(false);
    } else {
      if (phoneNumber?.slice(0, 1) !== "7" || phoneNumber.length !== 10) {
        setPhoneError("invalid");
        setLoading(false);
      } else {
        const cv = cryptoRandomString({ length: 128, type: "base64" });
        try {
          const frontendkey = await generateKeyPair();
          const body = {
            onmouuid: "SEED",
            code_challenge: sha256(cv),
            code_challenge_method: "S256",
            frontendkey: frontendkey.FE_PUB_KEY,
          };
          const response = await fetch("/api/onboarding/authinit", {
            method: "POST",
            body: JSON.stringify(body),
          });
          const res = await response.json();
          if (response.status === 200) {
            try {
              const tokens = {
                uuid: res?.onmouuid,
                onmoAT: res?.auth.accessToken,
              };
              const body = {
                phonenumber: "+44" + phoneNumber,
                link_url: "https://onmo.app/download-app",
              };
              const response = await fetch("/api/sendsms", {
                method: "POST",
                headers: { Authorization: `${tokens.onmoAT}` },
                body: JSON.stringify(body),
              });
              if (response.status === 200) {
                setLoading(false);
                setFormSent(true);
                setTimeout(() => {
                  setFormSent(false);
                }, 10000);
              } else {
                setLoading(false);
                setFormSent(true);
                setTimeout(() => {
                  setFormSent(false);
                }, 10000);
              }
            } catch (err) {
              setLoading(false);
              setFormSent(true);
              setTimeout(() => {
                setFormSent(false);
              }, 10000);
            }
          } else {
            setLoading(false);
            setFormSent(true);
            setTimeout(() => {
              setFormSent(false);
            }, 10000);
          }
        } catch (err) {
          setLoading(false);
          setFormSent(true);
          setTimeout(() => {
            setFormSent(false);
          }, 10000);
        }
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setFormSent(false);
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className={`${styles.modal} text-2xl text-center !min-h-min md:!w-auto md:max-h-[563px] lg:h-[560px] md:!px-10 md:!py-6 text-onmoText`}
      >
        <div
          className="float-right flex justify-end mt-2 mb-6 text-black cursor-pointer"
          onClick={() => {
            handleClose();
          }}
        >
          <CloseOutlined className="!w-8 !h-8" />
        </div>
        <div className="max-w-[1100px] xl:w-[1000px] p-3 md:p-6 rounded-[20px] content-center">
          <div
            className={`flex-col gap-5 md:gap-10 flex text-onmoText max-w-[808px] m-auto`}
          >
            <div className="flex flex-col md:flex-row  md:gap-8 lg:gap-5">
              <div className="self-center">
                <h1 className=" text-4xl md:text-6xl mb-4 font-ppNeue text-left w-max ">
                  Download app
                </h1>
                <div className=" md:flex flex-col md:flex-row flex-basis gap-5">
                  <div className="flex flex-col basis-full ">
                    <p className="text-sm md:text-[18px] text-left mb-8 max-w-[425px]">
                      To get started, scan the QR code and install the Onmo App.
                      Or if you enter your mobile number, we&apos;ll send you an
                      SMS with a download link.
                    </p>
                    {formSent ? (
                      <p className="text-[#00A556] text-left text-[18px] font-semibold">
                        A link has been sent to
                        <NumberFormat
                          value={phoneNumber}
                          format="+44 ****** ####"
                          allowEmptyFormatting
                          displayType="text"
                        />
                      </p>
                    ) : (
                      <>
                        <form className="flex flex-col gap-3 mb-8">
                          <div className="flex flex-col items-start gap-1">
                            <p className="text-sm">Phone number</p>
                            <NumberFormat
                              disabled={loading}
                              className={
                                styles.input +
                                " !rounded-md bg-[#F4F3FF] text-base md:w-[67%]"
                              }
                              format="+44 (0) #### ### ###"
                              mask=""
                              allowEmptyFormatting
                              onValueChange={v => {
                                setPhoneNumber(v.value);
                                if (v.value.slice(0, 1) !== "7") {
                                  setPhoneError("invalid");
                                } else {
                                  setPhoneError(false);
                                }
                              }}
                            />
                          </div>
                          {phoneError === "empty" ? (
                            <p className={styles.error}>
                              Please enter your phone number.
                            </p>
                          ) : phoneError === "invalid" ? (
                            <p className={styles.error}>
                              Invalid number entered. Please try again.
                            </p>
                          ) : null}
                        </form>
                        <button
                          disabled={phoneNumber === null || loading}
                          className="py-3 gap-2 px-3 text-base items-center flex max-w-[160px] mb-4 md:mb-0  w-full rounded-xl bg-onmoPrimary text-white 
                disabled:bg-onmoGrey-light "
                          onClick={formSubmit}
                        >
                          Text me a link
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.5 17.5L18.5 12.5L13.5 7.5"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M18.5 12.5L6.5 12.5"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full h-full flex flex-col items-center">
                <div className=" max-w-[247px] max-h-[247px] border border-[#cac2c2] border-opacity-50 rounded-[10px]">
                  <Image
                    src={"/images/newQr.svg"}
                    width={247}
                    height={247}
                    objectFit="contain"
                    alt="QR Download"
                  />
                </div>
                <div className="flex gap-3 items-center justify-center mt-3">
                  <a
                    aria-label="Google play store"
                    href="https://play.google.com/store/apps/details?id=app.onmo.v2&gl=UK"
                  >
                    <PlayStore />
                  </a>
                  <a
                    aria-label="Apple app store"
                    href="https://apps.apple.com/gb/app/onmo/id6498719371"
                  >
                    <AppleStore />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
